import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "On the buying of new hair and other silly stuff",
  "description": "",
  "published": "2010-08-23T00:00:00.000Z",
  "redirect_from": ["/blog/on-the-buying-of-new-hair-and-other-silly-stuff/swizec/1437"],
  "categories": "Hair, Hairstyle, Health, Long hair, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`It's not often that I go buy a new set of hair, actually I only do it once every two years or so. I don't really mind going, in fact I kind of like the type of pampering my hair can only get at a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Beauty_salon",
        "title": "Beauty salon"
      }}>{`hair salon`}</a>{`. And the girls there are always so nice and chatty. It's pretty cool.`}</p>
    <p>{`But I'm lazy.`}</p>
    <p>{`And I like longish hair. The good thing about `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Long_hair",
        "title": "Long hair"
      }}>{`long hair`}</a>{` is that it just sort of happens on its own, you don't have to really think too much. Once you get used to the mop it doesn't even take that long to wash, certainly not as long as some girls will have you think to get out of a date they don't want. Nope, nothing like having long hair. Who wants to be forced into going to the hairdresser's once a month to keep their 'do just the way they want it?`}</p>
    <p>{`Pffft.`}</p>
    <p>{`So anyway, today I went to CityPark because I wanted to try some new hair salon I'd never been to and the few times I passed this one it looked intriguing enough. Probably because of all the girls of Just The Right Age (tm) working in there.`}</p>
    <p>{`First thing I did was step up to a random pillar and take a Before photo:`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/08/IMG00443.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/08/IMG00443-300x225.jpg",
          "alt": null,
          "title": "Before"
        }}></img></a>{`If you look carefully you'll see the hair was pretty long. It was actually about two centimeters beyond nipple-length. Definitely time to get a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Hairstyle",
        "title": "Hairstyle"
      }}>{`haircut`}</a>{` because making a tail was getting annoying.`}</p>
    <p>{`The whole salon experience was pretty fun. The lass complained a lot about having to cut so much hair ... apparently it's a sin for people who want long hair but can't get them to make long hair short ... or something like that. There was also some complaining from the other girls about why they didn't get to cut me ... but since I don't know what that was about I'll just pretend they found me cute and wanted to touch my awesomeness :P`}</p>
    <p>{`Anyway, the hairdresser chick took the After photo and this is what my mop looks like now:`}</p>
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2010/08/IMG00445.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2010/08/IMG00445-300x225.jpg",
          "alt": null,
          "title": "After"
        }}></img></a>{`I actually quite like it. Turned out nice.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=eb95657e-4e29-4b56-a242-9092955a236b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      